/**
 * Completa tu look — Widget de cross-sell con selección de talla y add-to-cart.
 * Dos modos de render que comparten el mismo motor:
 *   - 'sheet'  → bottom sheet MOBILE (snippets/complete-the-look-mobile.liquid).
 *   - 'inline' → widget inline DESKTOP (snippets/complete-the-look-desktop.liquid).
 * Datos base: atributo data-ctl-data (metafield). Tallas/stock: /products/{handle}.js.
 * Tras agregar: dispatch 'ajaxProduct:added' → el cart drawer del tema se abre solo.
 */
(function () {
  'use strict';
  if (window.__ctlLoaded) return;
  window.__ctlLoaded = true;

  var productCache = {};

  // ── Textos traducidos ─────────────────────────────────────────────────
  // theme.strings.completeTheLook se define en layout/theme.liquid. Los
  // fallbacks en español replican el comportamiento previo si faltara.
  var S = (window.theme && window.theme.strings && window.theme.strings.completeTheLook) || {};

  // Se llama _t y no t: dentro de applyPreorder ya hay un callback con
  // parámetro `t`, y aunque el scope léxico lo resuelve bien, el nombre
  // colisionante se lee como un bug.
  function _t(key, fallback, vars) {
    var s = S[key] || fallback;
    if (!vars) return s;
    // Un solo pase: evita que un valor inyectado que contenga '[x]' se
    // re-reemplace en la sustitución siguiente.
    return String(s).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m;
    });
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Rutas localizadas ─────────────────────────────────────────────────
  // routes.root_url ('/' en el locale primario, '/en' en los demás) llega como
  // theme.routes.home. Sin este prefijo, /products/{handle}.js devolvía el
  // producto en el idioma primario: en /en las tallas y los títulos de los
  // complementos salían en español.
  //
  // Se llama _localeRoot y no root porque dentro de initWidget `root` es el
  // elemento DOM del widget.
  function _localeRoot() {
    var r = (window.theme && window.theme.routes && window.theme.routes.home) || '/';
    return String(r).replace(/\/+$/, '');
  }
  function productUrl(handle, suffix) {
    return _localeRoot() + '/products/' + handle + (suffix || '');
  }

  function money(cents) {
    return '$' + (Number(cents) / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function optionNames(p) {
    if (!p.options) return [];
    return p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  // Devuelve [{ value, id, price, available }] para la opción de talla del producto.
  function buildSizes(p) {
    var names = optionNames(p);
    var idx = -1;
    for (var i = 0; i < names.length; i++) {
      if (/talla|size/i.test(names[i] || '')) { idx = i; break; }
    }
    if (idx < 0) idx = 0;
    var key = 'option' + (idx + 1);

    var order = [];
    p.variants.forEach(function (v) {
      var val = v[key];
      if (val != null && order.indexOf(val) === -1) order.push(val);
    });

    return order.map(function (val) {
      var avail = null, any = null;
      for (var j = 0; j < p.variants.length; j++) {
        var v = p.variants[j];
        if (v[key] !== val) continue;
        if (!any) any = v;
        if (v.available) { avail = v; break; }
      }
      var chosen = avail || any;
      return { value: val, id: chosen.id, price: chosen.price, available: !!avail };
    });
  }

  // ctx: { mode:'sheet'|'inline', root, pill?, dataStr }
  function initWidget(ctx) {
    var mode    = ctx.mode;
    var root    = ctx.root;
    var pill    = ctx.pill || null;
    var panel   = root.querySelector('[data-ctl-panel]') || root;
    var body    = root.querySelector('[data-ctl-body]');
    var summary = root.querySelector('[data-ctl-summary]');
    var addBtn  = root.querySelector('[data-ctl-add]');
    var preNote = root.querySelector('[data-ctl-preorder-note]');

    // Cerrar es no-op salvo en modo sheet (se reasigna abajo).
    var closeSheet = function () {};

    // ── Parse datos base ──────────────────────────────────────────────
    var raw;
    try { raw = JSON.parse(ctx.dataStr); } catch (e) { raw = []; }
    if (!Array.isArray(raw)) raw = [];
    var base = raw.filter(function (p) { return p && p.available; });
    if (!base.length) {
      if (pill) pill.style.display = 'none';
      if (mode === 'inline') root.style.display = 'none';
      return;
    }

    // items: estado por prenda
    var items = base.map(function (p) {
      return {
        handle: p.handle,
        title: p.title,
        basePrice: p.price,
        selected: null,   // { id, price }
        soldOut: false,
        isPreorder: false,
        el: null,
        sizesEl: null,
        badgesEl: null
      };
    });

    // ── Render shells (imagen/nombre/precio) inmediato ────────────────
    body.innerHTML = '';
    items.forEach(function (item) {
      var p = base[items.indexOf(item)];
      var url = productUrl(item.handle);
      var el = document.createElement('div');
      el.className = 'ctl-item';
      el.innerHTML =
        '<div class="ctl-item__top">' +
          '<a class="ctl-item__thumb" href="' + url + '" target="_blank" rel="noopener">' +
            (p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="ctl-item__info">' +
            '<div class="ctl-item__nameRow">' +
              '<p class="ctl-item__name">' + (item.title || '') + '</p>' +
              '<span class="ctl-item__price">' + money(item.basePrice) + '</span>' +
            '</div>' +
            '<div class="ctl-item__badges" data-ctl-badges></div>' +
            '<span class="ctl-item__label">' + esc(_t('sizeLabel', 'Talla')) + '</span>' +
            '<div class="ctl-item__sizes" data-ctl-sizes><span class="ctl-item__label" style="margin:0">' + esc(_t('loading', 'Cargando…')) + '</span></div>' +
            '<a class="ctl-item__link" href="' + url + '" target="_blank" rel="noopener">' + esc(_t('viewProduct', 'Ver producto →')) + '</a>' +
          '</div>' +
        '</div>';
      item.el = el;
      item.sizesEl = el.querySelector('[data-ctl-sizes]');
      item.badgesEl = el.querySelector('[data-ctl-badges]');
      body.appendChild(el);
    });

    updateFooter();

    // ── Fetch tallas por prenda ───────────────────────────────────────
    items.forEach(function (item) {
      fetchProduct(item.handle).then(function (p) {
        applyPreorder(item, p);
        renderSizes(item, buildSizes(p));
      }).catch(function () {
        renderSizes(item, []);
      });
    });

    // ── Pre-order (tag "pre-order", igual que el cart drawer) ─────────
    function applyPreorder(item, p) {
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      item.isPreorder = tags.indexOf('pre-order') !== -1;
      if (item.isPreorder && item.badgesEl) {
        var pill = document.createElement('span');
        pill.className = 'ctl-item__preorder';
        pill.textContent = _t('preorder', 'Pre-order');
        item.badgesEl.appendChild(pill);
      }
      updatePreorderNote();
    }

    // Aviso en el footer: solo si algún complemento visible está en preventa.
    function updatePreorderNote() {
      if (!preNote) return;
      var any = items.some(function (i) { return i.isPreorder && !i.soldOut; });
      preNote.hidden = !any;
    }

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch(productUrl(handle, '.js'), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) { productCache[handle] = p; return p; });
    }

    function renderSizes(item, sizes) {
      var wrap = item.sizesEl;
      wrap.innerHTML = '';
      var hasAvailable = sizes.some(function (s) { return s.available; });

      if (!sizes.length || !hasAvailable) {
        item.soldOut = true;
        item.el.classList.add('ctl-item--sold-out');
        var so = document.createElement('span');
        so.className = 'ctl-item__soldout';
        so.textContent = _t('soldOut', 'Agotado');
        wrap.parentNode.replaceChild(so, wrap);
        item.sizesEl = null;
        updateFooter();
        updatePreorderNote();
        return;
      }

      sizes.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ctl-size' + (s.available ? '' : ' is-disabled');
        // El valor de talla es un codigo, nunca prosa: se marca para que los
        // traductores del navegador no lo reescriban (p.ej. "M" -> "METRO").
        btn.setAttribute('translate', 'no');
        btn.textContent = s.value;
        if (s.available) {
          btn.setAttribute('data-variant-id', s.id);
          btn.setAttribute('data-price', s.price);
          btn.addEventListener('click', function () {
            var wasSelected = btn.classList.contains('is-selected');
            wrap.querySelectorAll('.ctl-size').forEach(function (b) { b.classList.remove('is-selected'); });
            wrap.classList.remove('ctl-item__sizes--error');
            if (wasSelected) {
              // Volver a tocar la talla seleccionada la deselecciona:
              // esa prenda queda fuera del carrito.
              item.selected = null;
            } else {
              btn.classList.add('is-selected');
              item.selected = { id: s.id, price: s.price };
            }
            updateFooter();
          });
        } else {
          btn.setAttribute('aria-disabled', 'true');
        }
        wrap.appendChild(btn);
      });
    }

    // ── Footer / validación / total ───────────────────────────────────
    function activeItems() { return items.filter(function (i) { return !i.soldOut; }); }

    function updateFooter() {
      var active = activeItems();
      var baseCount = active.length;
      var selected = active.filter(function (i) { return i.selected; });
      var selCount = selected.length;
      var selTotal = selected.reduce(function (sum, i) { return sum + i.selected.price; }, 0);

      if (baseCount <= 1) {
        // Un solo complemento → sin resumen multi-producto.
        summary.hidden = true;
        var single = active[0];
        var price = single ? (single.selected ? single.selected.price : single.basePrice) : 0;
        addBtn.textContent = _t('addWithPrice', 'Agregar · [price]', { price: money(price) });
      } else {
        // Varios complementos → resumen de lo seleccionado (no se obliga a todas).
        summary.hidden = false;
        summary.innerHTML = '<strong>' + money(selTotal) + '</strong>';
        // "Agregar look completo" solo si TODAS las prendas tienen talla;
        // si la selección es parcial, se muestra el total de lo elegido.
        addBtn.textContent = (selCount === baseCount)
          ? _t('addFullLook', 'Agregar look completo')
          : _t('addWithPrice', 'Agregar · [price]', { price: money(selTotal) });
      }
      // Se habilita con al menos una prenda seleccionada.
      addBtn.disabled = selCount === 0;
    }

    // ── Add to cart ───────────────────────────────────────────────────
    addBtn.addEventListener('click', function () {
      // Solo se agregan las prendas con talla seleccionada (no se obliga a todas).
      var selected = activeItems().filter(function (i) { return i.selected; });
      if (!selected.length) return;

      var payload = { items: selected.map(function (i) { return { id: i.selected.id, quantity: 1 }; }) };
      addBtn.disabled = true;
      var prevText = addBtn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          addBtn.textContent = (res.data && res.data.description) || 'No disponible';
          setTimeout(function () { addBtn.textContent = prevText; addBtn.disabled = false; }, 2000);
          return;
        }
        addBtn.textContent = _t('added', '✓ Agregado');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: res.data, source: 'complete-the-look' }
        }));
        setTimeout(function () {
          if (mode === 'sheet') closeSheet();
          addBtn.textContent = prevText;
          addBtn.disabled = false;
        }, mode === 'sheet' ? 900 : 1200);
      })
      .catch(function () {
        addBtn.textContent = prevText;
        addBtn.disabled = false;
      });
    });

    // ── Interacción específica del bottom sheet (mobile) ──────────────
    if (mode !== 'sheet') return;

    var isOpen = false;
    function openSheet() {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ctl-lock');
      // fuerza reflow para que la transición corra
      void root.offsetWidth;
      root.classList.add('ctl-sheet--open');
      isOpen = true;
    }
    closeSheet = function () {
      isOpen = false;
      root.classList.remove('ctl-sheet--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ctl-lock');
      var done = function () {
        root.hidden = true;
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    };

    if (pill) pill.addEventListener('click', openSheet);
    root.querySelectorAll('[data-ctl-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeSheet();
    });

    // ── Swipe-to-dismiss (mismo patrón que el cart drawer) ────────────
    (function () {
      // Solo aplica en el layout de bottom-sheet (≤749px).
      var mq = window.matchMedia('(max-width: 749px)');

      var startY = 0, startX = 0;       // origen del gesto
      var lastY = 0, lastT = 0;         // última muestra (para velocidad)
      var dragStartY = 0;               // Y en el instante que empieza el arrastre del panel
      var velocity = 0;                 // px/ms (positivo = hacia abajo)
      var currentTranslate = 0;         // translateY aplicado actualmente
      var active = false;               // hay un touch en curso
      var decided = false;              // ya se resolvió la dirección del gesto
      var dragging = false;             // el panel está siguiendo al dedo

      function panelHeight() {
        return panel.offsetHeight || window.innerHeight;
      }

      function onStart(e) {
        if (!isOpen || !mq.matches || e.touches.length !== 1) return;
        active = true;
        decided = false;
        dragging = false;
        velocity = 0;
        currentTranslate = 0;
        var t = e.touches[0];
        startY = lastY = t.clientY;
        startX = t.clientX;
        lastT = Date.now();
      }

      function onMove(e) {
        if (!active || !mq.matches) return;
        var t  = e.touches[0];
        var dy = t.clientY - startY;
        var dx = t.clientX - startX;

        if (!decided) {
          // Umbral mínimo para evitar falsos positivos en taps.
          if (Math.abs(dy) < 6 && Math.abs(dx) < 6) return;
          decided = true;
          // El panel solo se arrastra si el gesto es predominantemente
          // vertical, hacia abajo, y el contenido ya está en su tope superior.
          var atTop = !body || body.scrollTop <= 0;
          if (dy > 0 && Math.abs(dy) > Math.abs(dx) && atTop) {
            dragging = true;
            dragStartY = t.clientY;
            panel.style.transition = 'none'; // seguir al dedo sin lag
          }
        }

        // Velocidad instantánea (para detectar flick rápido al soltar).
        var now = Date.now();
        var dt  = now - lastT;
        if (dt > 0) velocity = (t.clientY - lastY) / dt;
        lastY = t.clientY;
        lastT = now;

        if (dragging) {
          var move = t.clientY - dragStartY;
          if (move < 0) move = 0;        // nunca por encima de la posición abierta
          currentTranslate = move;
          panel.style.transform = 'translateY(' + move + 'px)';
          // Evita el scroll del navegador y el pull-to-refresh durante el arrastre.
          e.preventDefault();
        }
      }

      function onEnd() {
        if (!active) return;
        active = false;
        if (!dragging) return;
        dragging = false;

        panel.style.transition = ''; // restaurar la transición del CSS

        // Cerrar si se arrastró más del 30% del alto o fue un flick rápido.
        var shouldClose = currentTranslate > panelHeight() * 0.3 || velocity > 0.5;
        // En ambos casos quitamos el transform inline: al cerrar, la clase
        // --open desaparece (=> translateY(100%)); al volver, queda translateY(0).
        panel.style.transform = '';
        if (shouldClose) closeSheet();

        currentTranslate = 0;
        velocity = 0;
      }

      panel.addEventListener('touchstart', onStart, { passive: true });
      panel.addEventListener('touchmove',  onMove,  { passive: false });
      panel.addEventListener('touchend',   onEnd);
      panel.addEventListener('touchcancel', onEnd);
    })();
  }

  // ── Bootstrap: init de sheets (mobile) e inline (desktop) ───────────
  function boot() {
    // Bottom sheet mobile
    document.querySelectorAll('[data-ctl-open]').forEach(function (pill) {
      var scope = pill.closest('.product__photos') || document;
      var sheet = scope.querySelector('.ctl-sheet');
      if (!sheet || sheet.__ctlInit) return;
      var dataStr = sheet.getAttribute('data-ctl-data');
      if (!dataStr) return;
      sheet.__ctlInit = true;
      initWidget({ mode: 'sheet', root: sheet, pill: pill, dataStr: dataStr });
    });

    // Widget inline desktop
    document.querySelectorAll('.ctl-inline[data-ctl-data]').forEach(function (root) {
      if (root.__ctlInit) return;
      var dataStr = root.getAttribute('data-ctl-data');
      if (!dataStr) return;
      root.__ctlInit = true;
      initWidget({ mode: 'inline', root: root, dataStr: dataStr });
    });
  }

  // Expuesto para re-hidratar tras un swap AJAX del PDP (color-swatch-ajax.js).
  // El guard window.__ctlLoaded impide que el <script> re-inyectado vuelva a
  // correr boot(), así que el swap dejaría el widget sin bindear; llamar a
  // window.__ctlBoot() reinicializa los nodos nuevos (inline desktop y sheet mobile).
  window.__ctlBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
